import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { DropdownItem, LockDropdownItem, Tab } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledEnrichmentTabsContainer = styled.div`
    display: flex;
    width: 100%;
    .react-tabs {
        width: 100%;
    }
`;

export const StyledEnrichmentEmptyStateContainer = styled(Box)`
    text-align: center;
`;

export const StyledEnrichmentHistoryContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    border-radius: 6px;
    margin-top: 16px;
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledEnrichmentQuotaAndUpload = styled(FlexRow)`
    gap: 16px;
`;

export const StyledLoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 158px;
`;

export const StyledTab = styled(Tab)`
    font-family: "DM Sans", sans-serif !important;
`;

export const StyledLockDDItem = styled(LockDropdownItem)`
    ${setFontVariant("input2")}
    line-height: 42px;
`;

export const StyledDDItem = styled(DropdownItem)`
    ${setFontVariant("input2")}
`;

export const StyledAccountPageLink = styled.a`
    ${setFontVariant("tooltip", colorsPalettes.blue[300])}
    text-decoration: none;
`;
